@if (columns.length > 0) {
  <app-table
    (columnSelectionChange)="columnSelectionChange($event)"
    (focusDateChange)="focusDateChange($event)"
    (selectionChange)="selectionChange($event)"
    [columns]="columns"
    [columnSelectable]="true"
    [columnSelection]="columnSelection"
    [dataKey]="'id'"
    [firstColumnFrozen]="true"
    [focusDate]="focusDate"
    [focusDateClearable]="false"
    [hasFocusDate]="true"
    [headerGroups]="headerGroups"
    [loading]="loading"
    [selectable]="true"
    [selection]="selection"
    [singleRowToolbar]="true"
    [sortField]="'name'"
    [value]="value">
    <ng-template
      (onClick)="view.toggle($event)"
      [disabled]="tree.length === 0"
      appToolbarButton
      icon="fal fa-bars"
      labelKey="GLOBAL.VIEW"></ng-template>
    <ng-template
      (onClick)="organisationalUnitOverlayPanel.toggle($event)"
      appToolbarButton
      icon="fal fa-sitemap"
      labelKey="ASSIGNMENT.ORGANISATIONAL_UNIT_FILTER"></ng-template>
    @if (showPersonnelCategories && isManager()) {
      <ng-template
        (onClick)="personnelCategoryOverlayPanel.toggle($event)"
        appToolbarButton
        icon="fal fa-plus"
        labelKey="ASSIGNMENT.ADD_PERSONNEL_CATEGORY"></ng-template>
    }
    @if (isVariableAssignment()) {
      <ng-template
        (onClick)="toggleMeasures()"
        [labelKey]="showMeasure ? 'ASSIGNMENT.HIDE_MEASURES' : 'ASSIGNMENT.SHOW_MEASURES'"
        appToolbarButton
        icon="fal fa-hand-holding-medical"></ng-template>
    }
    @if (showEmployments && isManager()) {
      <ng-template
        (onClick)="employmentOverlayPanel.show($event)"
        appToolbarButton
        icon="fal fa-plus"
        labelKey="ASSIGNMENT.ADD_EMPLOYMENT"></ng-template>
    }
    @if (isManager()) {
      <ng-template
        (onClick)="showActivate()"
        [disabled]="!activeEnabled"
        appToolbarButton
        icon="fal fa-play-circle"
        labelKey="ACTIONS.ACTIVATE"></ng-template>
      <ng-template
        (onClick)="showDeactivate()"
        [disabled]="!deactivateEnabled"
        appToolbarButton
        icon="fal fa-stop-circle"
        labelKey="ACTIONS.DEACTIVATE"></ng-template>
    }
    @if (isVariableAssignment()) {
      <ng-template
        (onClick)="showHandbookDownload($event, handbookOverlay)"
        appToolbarButton
        icon="fal fa-book"
        labelKey="ASSIGNMENT.HANDBOOK_DOWNLOAD"></ng-template>
    }
  </app-table>
}

<p-popover
  (onHide)="loadAssignments()"
  [hideTransitionOptions]="'0ms'"
  [showTransitionOptions]="'0ms'"
  [style]="{ width: '500px' }"
  #organisationalUnitOverlayPanel>
  <div class="grid grid-cols-12">
    <div class="col-span-12">
      <p-button
        (onClick)="visibleColumns = flattenTree(tree)"
        [label]="'ACTIONS.SELECT_ALL' | translate"
        icon="fal fa-check-square"
        styleClass="p-button-text"></p-button>
      <p-button
        (onClick)="visibleColumns = []"
        [label]="'ACTIONS.DESELECT_ALL' | translate"
        icon="fal fa-square"
        styleClass="p-button-text"></p-button>
      <p-tree
        [(selection)]="visibleColumns"
        [filter]="true"
        [style]="{ width: '100%' }"
        [value]="tree"
        scrollHeight="calc(100vh - 400px)"
        selectionMode="checkbox"></p-tree>
    </div>

    @if (visibleColumns.length > maxColumns) {
      <div class="col-span-12">
        <p-message [text]="'ASSIGNMENT.TOO_MANY_COLUMNS' | translate" severity="warn"></p-message>
      </div>
    }

    <div class="col-span-12">
      <p-button
        (onClick)="organisationalUnitOverlayPanel.hide()"
        [label]="'ACTIONS.OK' | translate"
        icon="fal fa-check"></p-button>
    </div>
  </div>
</p-popover>

<p-popover
  [dismissable]="false"
  [hideTransitionOptions]="'0ms'"
  [showTransitionOptions]="'0ms'"
  [style]="{ width: '500px' }"
  #personnelCategoryOverlayPanel>
  <div class="grid grid-cols-12">
    <div class="col-span-12">
      <p-tree
        [style]="{ width: '100%' }"
        [value]="tree"
        #organizations
        scrollHeight="calc(100vh - 200px)"
        selectionMode="checkbox"></p-tree>
    </div>
    <div class="col-span-12">
      <p-select
        [filter]="true"
        [filterBy]="'label'"
        [options]="activePersonnelCategories"
        [placeholder]="'ASSIGNMENT.SELECT_PERSONNEL_CATEGORY' | translate"
        [style]="{ width: '100%' }"
        #personnelCategory
        appendTo="body"
        appScrollIntoView></p-select>
    </div>
    <div class="col-span-12">
      <p-button
        (onClick)="
          addPersonnelCategory(organizations.selection(), personnelCategory.value, personnelCategoryOverlayPanel)
        "
        [disabled]="!($any(organizations.selection())?.length > 0 && personnelCategory.value)"
        [label]="'ACTIONS.OK' | translate"
        [style]="{ 'margin-right': '0.5rem' }"
        icon="fal fa-check"></p-button>
      <p-button
        (onClick)="personnelCategoryOverlayPanel.hide()"
        [label]="'ACTIONS.CANCEL' | translate"
        icon="fal fa-times"
        styleClass="p-button-secondary"
        type="button"></p-button>
    </div>
  </div>
</p-popover>

<p-popover
  [dismissable]="false"
  [hideTransitionOptions]="'0ms'"
  [showTransitionOptions]="'0ms'"
  #employmentOverlayPanel>
  <div class="grid grid-cols-12">
    <div class="col-span-12">
      <p-select
        [filter]="true"
        [filterBy]="'label'"
        [options]="employments"
        [placeholder]="'ASSIGNMENT.SELECT_EMPLOYMENT' | translate"
        [style]="{ width: '100%' }"
        #employment
        appendTo="body"
        appScrollIntoView></p-select>
    </div>
    <div class="col-span-12">
      <p-button
        (onClick)="addEmployment(employment.value, employmentOverlayPanel)"
        [disabled]="!employment.value"
        [label]="'ACTIONS.OK' | translate"
        [style]="{ 'margin-right': '0.5rem' }"
        icon="fal fa-check"></p-button>
      <p-button
        (onClick)="employmentOverlayPanel.hide()"
        [label]="'ACTIONS.CANCEL' | translate"
        icon="fal fa-times"
        styleClass="p-button-secondary"
        type="button"></p-button>
    </div>
  </div>
</p-popover>

<p-dialog
  [(visible)]="displayActivateDialog"
  [header]="'ASSIGNMENT.ACTIVATE_SELECTED' | translate"
  [modal]="true"
  [style]="{ width: '700px' }">
  @if (form) {
    <form (ngSubmit)="saveActivate()" [formGroup]="form" class="grid grid-cols-12" novalidate>
      <app-form-date-input
        [form]="form"
        [minDate]="validFrom!"
        [twoColumns]="false"
        id="from"
        label="GLOBAL.GUELTIG_AB"></app-form-date-input>
      <app-form-date-input
        [form]="form"
        [maxDate]="validTo!"
        [twoColumns]="false"
        id="to"
        label="GLOBAL.GUELTIG_BIS"></app-form-date-input>
      <app-form-button-bar
        (onCancel)="displayActivateDialog = false"
        [form]="form"
        [saveDisabled]="submitting"></app-form-button-bar>
    </form>
  }
</p-dialog>

<p-tieredMenu
  (click)="view.hide()"
  [hideTransitionOptions]="'0ms'"
  [model]="viewMenuModel"
  [popup]="true"
  [showTransitionOptions]="'0ms'"
  [style]="{ width: '300px' }"
  #view></p-tieredMenu>

<p-popover
  [hideTransitionOptions]="'0ms'"
  [showTransitionOptions]="'0ms'"
  [style]="{ width: '500px' }"
  #handbookOverlay>
  <div class="grid grid-cols-12">
    <div class="col-span-12">
      <p-tree [style]="{ width: '100%' }" [value]="handbookTree" scrollHeight="calc(100vh - 200px)">
        <ng-template let-node pTemplate="default">
          <span>{{ node.label }}</span>
          &nbsp;
          <a (click)="node.data('pdf')" class="fal fa-file-pdf"></a>
          &nbsp;
          @if (isRodixAdmin()) {
            <a (click)="node.data('word')" class="fal fa-file-word"></a>
          }
        </ng-template>
      </p-tree>
    </div>
  </div>
</p-popover>
